import { Link } from "react-scroll";

/*--------------------
* Footer
----------------------*/
function Footer() {
  return (
    <footer className="bg-night-950 border-t border-white/[0.06] py-8">
      <div className="container">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <Link smooth={true} to="home" className="cursor-pointer">
            <img
              className="h-[26px] w-auto brightness-0 invert opacity-70 hover:opacity-100 transition-opacity duration-200"
              src="img/logo+text.svg"
              title="Twilight Tier"
              alt="Twilight Tier"
            />
          </Link>
          <p className="m-0 font-mono text-[12px] tracking-[1px] text-mist-500 text-center">
            © {new Date().getFullYear()} Twilight Tier LLC — built after hours.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
